import { Controller } from 'react-hook-form'

const HiddenWrapper = ({ control, formField, fieldArrayName, fieldArrayIndex }) => {
  const getFieldName = () => {
    if (fieldArrayName && fieldArrayIndex !== undefined) {
      return `${fieldArrayName}.${fieldArrayIndex}.${formField.name}`
    }
    return formField.name
  }

  return (
    <Controller
      control={control}
      defaultValue={formField.defaultValue}
      name={getFieldName()}
      render={({ field }) => <input type="hidden" {...field} value={field.value || ''} />}
    />
  )
}

export default HiddenWrapper
